import { useTranslation } from "react-i18next";
import React from 'react';
export default function AddOnCard({
  addon,
  isAdded,
  onToggle
}) {
  const {
    t
  } = useTranslation();
  return <div className="addon-card">
      <div className="addon-info">
        <div className="addon-name">{addon.name}</div>
        <div className="addon-desc">{addon.description}</div>
      </div>
      <div className="addon-pricing-actions">
        <div className="addon-price">
          ${parseFloat(addon.monthly_price).toFixed(2)}
          <span className="addon-price-period">{t("/mo")}</span>
        </div>
        <button onClick={() => onToggle(addon)} className={`addon-btn ${isAdded ? 'added' : ''}`}>
          {isAdded ? 'Remove' : 'Add'}
        </button>
      </div>
    </div>;
}